import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FaIcon } from '../../../shared/components'

class MenuBar extends Component {
  constructor(props){
    super(props)
  }

  render(){
    return (
      <div className="dashboard-menu-bar md-visible">
        <button className="dashboard-menu-hamburger-button" onClick={ () => this.props.toggleMenu() }>
          <FaIcon icon='bars' />
        </button>
      </div>
    )
  }
}

MenuBar.propTypes = {
  toggleMenu: PropTypes.func,
}

export default MenuBar
